import { Component, Input, ViewEncapsulation, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

@Component({
    selector     : 'fuse-navigation',
    templateUrl  : './navigation.component.html',
    styleUrls    : ['./navigation.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class FuseNavigationComponent implements OnInit
{
    private _data = new BehaviorSubject<Array<any>>([]);
    crmNavigation: any;
    @Input() layout = 'vertical';
   @Input()
   set navigation(value) {
        this._data.next(value);
    }

    get navigation() {
        return this._data.getValue();
    }

    constructor()
    {

    }

    ngOnInit() {
        this._data
            .subscribe(x => {
                this.crmNavigation = x;
            });
    }
}



// WEBPACK FOOTER //
// ./src/@fuse/components/navigation/navigation.component.ts